<template>
	<div class="order-page page">
		<NavBar
			title="确认订单"
			left-arrow
			@click-left="onClickLeft"
		/>
		<div class="good-item">
			<VanImage
				class="good-item-img"
				width="4.5rem"
				height="4.5rem"
				:src="target.goodsImages && target.goodsImages[0].imageUrl"/>
			<div class="good-item-content">
				<div class="good-item-title">{{ target.goodsInfo && target.goodsInfo.goodsName }}</div>
				<div class="good-item-info">
					<span>监控价格：</span>
					<span class="text-price">{{target.goodsInfo &&  target.goodsInfo.price }} /天</span>
				</div>
			</div>
		</div>
		<div>
			<Cell class="mark-cell">
				<template #title>
					<p style="text-align: left">监控天数</p>
				</template>
				<template>
					<Stepper @change="onDaysChange" v-model="days" />
				</template>
			</Cell>
			<Field
				v-model="mark"
				rows="5"
				autosize
				label="买家备注"
				type="textarea"
				placeholder="请输入您的备注信息"
			/>
			<Cell>
				<template>
					<p style="text-align: right"><span>共 {{ days }} 天监管服务</span><span style="margin-left:10px">小计</span><span class="text-price">{{ totalMoney }}</span></p>
				</template>
			</Cell>
		</div>
		<SubmitBar :price="totalMoneyFen" button-text="提交订单" @submit="onSubmit" :loading="loading" />
	</div>
</template>

<script>
import request from '../request';
import { NavBar, Image as VanImage, Cell, Field, SubmitBar, Stepper } from 'vant';

export default {
  components: {NavBar, VanImage, Cell, Field, SubmitBar, Stepper},
  data() {
    return {
      mark: '',
      loading: false,
      days: 1,
      target: {},
      totalMoney: 0
    }
  },
  computed: {
    totalMoneyFen() {
      return this.totalMoney * 100
    }
  },
  created() {
    if(this.$router.isBack) return;
    const target = this.$route.params;
    this.target = target;
    this.totalMoney = this.target.goodsInfo.price;
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    async onSubmit() {
      this.loading = true;
      await this.$store.dispatch('handleOrder', [{ goodsInfoId: this.target.goodsInfo.id, goodsNum: this.days, remark: this.mark}]);
      this.loading = false;
    },
    onDaysChange(value, detail) {
      this.totalMoney = this.target.goodsInfo.price * value
    }
  }
}
</script>

<style lang="less" scoped>
	.page {
		height: 100%;
		background: #f5f5f5;
	}

	.good-item {
		display: flex;
		align-items: center;
		padding: 10px 10px;
		background-color: white;
		margin-top: 10px;

		&-img {
		}
		&-content {
			flex: 1;
			padding: 0 10px;
		}
		&-title {
			text-align: left;
		}
		&-info {
			text-align: right;
			font-size: 14px;
			color: #666;
		}
	}

	.text-price {
		color: red;
		font-weight: bolder;
		margin: 0 10px;
		.jiao {
			font-size: 18px;
		}
	}

	.mark-cell {
		margin-top: 10px;
	}
</style>
